import { Grid, Card, Typography, Box } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { CheckCircleOutline, DiamondOutlined } from "@mui/icons-material";
interface ItemProps {
  icon: any;
  title: string;
  value: string | number;
}
const Item = ({ icon, title, value }: ItemProps) => (
  <Card
    sx={{
      padding: 2,
      marginBottom: 2,
      background: "#fafafa",
      boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
      borderRadius: "10px",
    }}
  >
    <Grid container alignItems="center" spacing={2}>
      <Grid item>{icon}</Grid>
      <Grid item xs>
        <Typography variant="caption">{title}</Typography>
        <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
          {value != null && value !== "" ? String(value) : "—"}
        </Typography>
      </Grid>
    </Grid>
  </Card>
);

const CustomerProfile = ({ customer }: any) => {
  if (!customer) return <p>Loading...</p>;

  // Convert values for UI
  const statusText = customer.is_active === 1 ? "Active" : "Inactive";
  const priorityText = customer.is_priority === 1 ? "Premium" : "Not Premium";

  return (
    <Box sx={{ paddingTop: 3 }}>
      <Typography variant="h6" mb={3}>
        Company Profile
      </Typography>

      <Grid container spacing={2}>
        {/* Left Column */}
        <Grid item xs={12} md={6}>
          <Item
            icon={<BusinessIcon color="success" />}
            title="Name"
            value={customer.name}
          />

          <Item
            icon={<PhoneIcon color="success" />}
            title="Phone Number"
            value={customer.phone}
          />
          <Item
            icon={<DiamondOutlined color="success" />}
            title="Premium"
            value={priorityText}
          />
        </Grid>

        {/* Right Column */}
        <Grid item xs={12} md={6}>
          <Item
            icon={<EmailIcon color="success" />}
            title="Email Address"
            value={customer.email}
          />
          <Item
            icon={<CheckCircleOutline color="success" />}
            title="Status"
            value={statusText}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomerProfile;
